import React from 'react';
import { useTranslation } from 'react-i18next';
import SimpleModal from 'components/SimpleModal';
import { jsx as _jsx } from "react/jsx-runtime";
var ConfirmationModal = function ConfirmationModal(_ref) {
  var isLoading = _ref.isLoading,
    isEditMode = _ref.isEditMode,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(SimpleModal, {
    title: isEditMode ? t('actions_quit_editing_your_asset') : t('actions_quit_creating_asset'),
    body: isEditMode ? t('modal_confirm_quit_asset_editing_without_save') : t('modal_confirm_quit_asset_creation_without_save'),
    buttons: [{
      label: t('actions_cancel'),
      onClick: onCancel,
      isLoading: isLoading
    }, {
      label: t('actions_confirm'),
      onClick: onConfirm,
      variant: 'primary',
      isLoading: isLoading
    }],
    onClose: onCancel
  });
};
export default ConfirmationModal;